import { render, staticRenderFns } from "./container-form.component.vue?vue&type=template&id=c970cf8e&scoped=true"
import script from "./container-form.component.vue?vue&type=script&lang=js"
export * from "./container-form.component.vue?vue&type=script&lang=js"
import style0 from "./container-form.component.vue?vue&type=style&index=0&id=c970cf8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c970cf8e",
  null
  
)

export default component.exports